/**
 * @module app.UserController
 */
import appBase from './index.js';
import {deleteCookies} from './cookieshelper.js';
import {useCookieBasedAuth} from './authMode.js';

/**
 * @return {angular.Directive} The directive specs.
 * @ngInject
 */
appBase.userDirective = function() {
  return {
    restrict: 'E',
    controller: 'AppUserController',
    controllerAs: 'userCtrl',
    bindToController: true,
    templateUrl: 'partials/user.html'
  };
};

appBase.directive('appUser', appBase.userDirective);


/**
 * See http://timothy.userapp.io/post/63412334209
 * @return {angular.Directive} The directive specs.
 * @ngInject
 */
appBase.loginSubmitDirective = function() {
  return {
    restrict: 'A',
    require: ['^appUser'],
    link: function(scope, element, attrs, ctrls) {
      const userCtrl = ctrls[0];
      $(element)[0].onsubmit = () => {
        if (useCookieBasedAuth) {
          const username = $('#username', element).val();
          const password = $('#password', element).val();
          $('#login-username').val(String(username));
          $('#login-password').val(String(password));
          deleteCookies();
          userCtrl.loginWithCredentials_(function() {
            // reload page
            window.location.reload();
          });
        } else {
          deleteCookies();
          userCtrl.authentication_.loginWithKeycloak();
        }
        return false;
      };
    }
  };
};

/**
 * @return {angular.Directive} The directive specs.
 */
appBase.validateUserFormDirective = function() {
  return {
    require: ['^appUser', 'ngModel'],
    link: function(scope, elm, attrs, ctrls) {

      const userCtrl = ctrls[0];
      const modelCtrl = ctrls[1];

      modelCtrl.$validators.validateLoginFormInput = (modelValue, viewValue) => {
        // reset login error
        userCtrl.updateErrorMsg_('login', '');
        if (!useCookieBasedAuth) {
          userCtrl.setFormState_(modelCtrl.$name, true);
          return true;
        }

        if (modelCtrl.$isEmpty(modelValue) && modelCtrl.$dirty) {
          userCtrl.setFormState_(modelCtrl.$name, false);
          return false;
        }

        userCtrl.setFormState_(modelCtrl.$name, true);
        return true;
      };
    }
  };
};

appBase.directive('appValidateUserForm', appBase.validateUserFormDirective);

appBase.directive('appLoginSubmit', appBase.loginSubmitDirective);


/**
 * @param {angular.Scope} $scope
 * @param {gettext} gettext function for dynamic i18n.
 * @param {angularGettext.Catalog} gettextCatalog
 * @param {!app.AuthenticationService} appAuthenticationService
 * @param {!app.CesiumLoader} appCesiumLoader
 * @constructor
 * @ngInject
 */
class UserController {
  constructor($scope, gettext, gettextCatalog, appAuthenticationService, appCesiumLoader) {

    /**
     * @type {angular.Scope}
     * @private
     */
    this.scope_ = $scope;

    /**
     * Used by the partial
     * @export
     */
    this.useCookieBasedAuth = useCookieBasedAuth;

    /**
     * @private
     */
    this.authentication_ = appAuthenticationService;

    /**
     * @private
     */
    this.cesium_ = appCesiumLoader;

    /**
     * @type {string}
     * @private
     */
    this.emptyLoginMsg_ = gettext('login must not be empty');

    /**
     * @type {string}
     * @private
     */
    this.emptyPasswordMsg_ = gettext('password must not be empty');

    /**
     * @export
     */
    this.gettextCatalog = gettextCatalog;

    /**
     * @type {boolean}
     */
    this.loggedIn;
    Object.defineProperty(this, 'loggedIn', {
      get: () => {
        return this.authentication_.loggedIn;
      }
    });

    Object.defineProperty(this, 'errorMessages', {
      get: () => {
        return Object.values(this.authentication_.errorMessages);
      }
    });

    Object.defineProperty(this, 'data', {
      get: () => {
        return this.authentication_.data;
      }
    });

    Object.defineProperty(this, 'loginConfig', {
      get: () => {
        return this.authentication_.loginConfig;
      }
    });
  }

  /**
   * @param {function()} loginCb Callback triggered when authentication succeeds.
   * @private
   */
  loginWithCredentials_(loginCb) {
    const credentials = {
      'username': $('#username').val(),
      'password': $('#password').val()
    };

    let valid = true;
    if (!credentials['username']) {
      this.setFormState_('username', false);
      valid = false;
    }
    if (!credentials['password']) {
      this.setFormState_('password', false);
      valid = false;
    }
    if (!valid) {
      this.scope_.$digest();
      return;
    }

    this.authentication_.loginWithCookie(credentials, () => {
      // Force reload of the page
      loginCb();
    });
  }

  /**
   * @export
   */
  delog() {
    this.authentication_.delog();
  }


  /**
   * @private
   * @param {string} input name of related input whose state has changed
   * @param {boolean} state state of the input
   * Set error message for login / password input validation
   */
  setFormState_(input, state) {
    let msg = '';
    if (!state) {
      if (input == 'username') {
        msg = this.emptyLoginMsg_;
      } else {
        msg = this.emptyPasswordMsg_;
      }
    }
    this.updateErrorMsg_(input, msg);
  }

  /**
   * @private
   * @param {string} id
   * @param {string} msg
   */
  updateErrorMsg_(id, msg) {
    this.authentication_.updateErrorMsg(id, msg);
  }

  /**
   * Check with the server if the user is logged in and notify the caller.
   * Additionnaly, if the user is not logged in, call logout to reset the
   * interface.
   * @param {function(boolean)} callback
   */
  isUserLoggedIn(callback) {
    this.authentication_.isUserLoggedIn(callback);
  }

}

export default appBase.controller('AppUserController', UserController);
